import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { DownVideo } from "../../components/down-video/DownVideo";
import { TopLine } from "../../components/top-line/TopLine";
import './repair-options.scss';
import { RepairMode, repairMode } from "../order-end/orderEndSlice";
import useSmartHistory from "../../metrica/metrica";
import { selectBoxId, selectIsFreeOrder } from "../home/homeSlice";
import { selectExpireDate, selectExpireDateValue } from "../saled-window/saledWindowSlice";

export function RepairOptions() {
    let navigate = useSmartHistory();
    let dispatch = useDispatch()
    let isFreeOrder = useSelector(selectIsFreeOrder)
    let expireDate = useSelector(selectExpireDateValue)
    let toNext = (mode: RepairMode) => {

        dispatch({
            type: "CLEANUP",
            mode: mode
        })
        //  dispatch(repairMode(mode))
        navigate.push('/order-defects')


    }
    let targetDate = (expireDate ?? new Date()).getTime()
    const currentDate = new Date().getTime();

    // Создаём переменную с целевой датой - 20 июля 2024 года
    // const targetDate = new Date('2024-09-19').getTime();

    // Вычисляем разницу в миллисекундах между двумя датами
    const differenceInMillis = targetDate - currentDate;

    // Преобразуем миллисекунды в дни (1 день = 24 часа * 60 минут * 60 секунд * 1000 миллисекунд)
    const millisInDay = 24 * 60 * 60 * 1000;
    const daysCount = Math.ceil(differenceInMillis / millisInDay);

    // Выводим количество дней до целевой даты
    console.log(`Количество дней до 20 июля 2024 года: ${daysCount}`);
    let isAction = daysCount > 0 && isFreeOrder
    return (<>
        <TopLine sectionStyle='left' sectionText='!' sectionHeading='' sectionType='text' >
            <div> Выберите условия <span className="primaryText">ремонта</span> </div>
        </TopLine>
        <div className="repair-options-cards-container">
            <div className="repair-options-cards">
                {/* Срочный ремонт */}
                <div
                    className="repair-card urgent"
                    onClick={() => toNext(RepairMode.Faster)}
                >
                    <div className="repair-card__icon-center">
                        {/* SVG молния */}
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="28" height="28" rx="8" fill="#222" />
                            <path d="M13.5 6L8 16H13L12 22L19 12H14L15 6H13.5Z" fill="#F6FF4A" />
                        </svg>
                    </div>
                    <div className="repair-card__title-center">Срочный ремонт</div>
                    <div className="repair-card__desc">
                        Заберите свое отремонтированное устройство уже завтра за доплату
                    </div>
                    <div className="repair-card__price-row">
                        <span className="repair-card__price-new">400Р</span>
                    </div>
                    <div className="repair-card__warranty">Гарантия 90 дней</div>
                    <div className="repair-card__time">24 часа</div>
                </div>

                {/* Без доплат */}
                <div
                    className="repair-card free"
                    onClick={() => toNext(RepairMode.Free)}
                >
                    <div className="repair-card__icon-center">
                        {/* SVG шестерёнка */}
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="28" height="28" rx="8" fill="#222" />
                            <path d="M14 10.5A3.5 3.5 0 1 1 10.5 14 3.5 3.5 0 0 1 14 10.5m0-2A5.5 5.5 0 1 0 19.5 14 5.5 5.5 0 0 0 14 8.5Zm7.5 5.5a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1.09a7.07 7.07 0 0 1-.36 1l.77.77a1 1 0 0 1 0 1.41l-1.41 1.41a1 1 0 0 1-1.41 0l-.77-.77a7.07 7.07 0 0 1-1 .36V21a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1.09a7.07 7.07 0 0 1-1-.36l-.77.77a1 1 0 0 1-1.41 0l-1.41-1.41a1 1 0 0 1 0-1.41l.77-.77a7.07 7.07 0 0 1-.36-1H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1.09a7.07 7.07 0 0 1 .36-1l-.77-.77a1 1 0 0 1 0-1.41l1.41-1.41a1 1 0 0 1 1.41 0l.77.77a7.07 7.07 0 0 1 1-.36V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.09a7.07 7.07 0 0 1 1 .36l.77-.77a1 1 0 0 1 1.41 0l1.41 1.41a1 1 0 0 1 0 1.41l-.77.77a7.07 7.07 0 0 1 .36 1H21Z" fill="#F6FF4A" />
                        </svg>
                    </div>
                    <div className="repair-card__title-center">Без доплат</div>
                    <div className="repair-card__desc">
                        Классический ремонт устройства без доплат за скорость
                    </div>
                    <div className="repair-card__price-row">
                        <span className="repair-card__price-new">0Р</span>
                    </div>
                    <div className="repair-card__warranty">Гарантия 30 дней</div>
                    <div className="repair-card__time">до 48 часов</div>
                </div>
            </div>
            <div className="subtitle">Точная стоимость - после бесплатной диагностики
                <br />
            Позвоните нам или напишите в мессенджер, и мы назовем стоимость заранее</div>
        </div>

        <div className="defects_buttons">
            <button onClick={() => { navigate.push('/') }} className="main-button black back">Назад</button>
            <button className={`main-button yellow next invisible`} >Далее</button>
        </div>
        <DownVideo />
    </>)

}
